import { Search, X } from "lucide-react";

export const ProductFilters = ({ search, setSearch, category, setCategory, size, setSize, brand, setBrand, categories, sizes, brands, resultCount }) => {
  const hasFilters = search || category || size || brand;
  const selectCls = "bg-[#121212] border border-white/10 text-white px-3 py-2 text-sm rounded-xl focus:border-[#00FF66] focus:outline-none";
  return (
    <div className="flex flex-wrap items-center gap-3 mb-5" data-testid="admin-filters">
      <div className="relative flex-1 min-w-[12rem]">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#A0A0A0]" />
        <input
          type="text"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Buscar por nombre, marca o talla..."
          className="w-full bg-[#121212] border border-white/10 text-white pl-9 pr-3 py-2 text-sm rounded-xl focus:border-[#00FF66] focus:outline-none placeholder-[#A0A0A0]/50"
          data-testid="admin-search-input"
        />
      </div>
      <select value={category} onChange={(e) => setCategory(e.target.value)} className={selectCls} data-testid="admin-category-filter">
        <option value="">Todas las categorias</option>
        {categories.map(c => <option key={c.value} value={c.value}>{c.label}</option>)}
      </select>
      <select value={brand} onChange={(e) => setBrand(e.target.value)} className={selectCls} data-testid="admin-brand-filter">
        <option value="">Todas las marcas</option>
        {brands.map(b => <option key={b} value={b}>{b}</option>)}
      </select>
      <select value={size} onChange={(e) => setSize(e.target.value)} className={selectCls} data-testid="admin-size-filter">
        <option value="">Todas las tallas</option>
        {sizes.map(s => <option key={s} value={s}>{s}</option>)}
      </select>
      <span className="text-xs text-[#A0A0A0]" data-testid="admin-filter-count">{resultCount} resultado{resultCount !== 1 ? "s" : ""}</span>
      {hasFilters && (
        <button onClick={() => { setSearch(""); setCategory(""); setSize(""); setBrand(""); }} className="text-xs text-[#00FF66] flex items-center gap-1 hover:underline" data-testid="admin-clear-filters">
          <X className="w-3 h-3" /> Limpiar
        </button>
      )}
    </div>
  );
};
